import { State } from '../../(common-lib)/LoanData';
import type { USState } from '../../(ui-lib)/address/types';

export function isDashboardPage(pathname: string): boolean {
  const dashboardPages = ['/loanapp'];
  const dashboardPage = dashboardPages.some(page => pathname === page);
  return dashboardPage;
}

export function isNewLoanPage(pathname: string): boolean {
  return pathname?.startsWith('/loanapp/new-loan');
}

export function isAdminPage(pathname: string): boolean {
  return pathname?.startsWith('/loanapp/admin');
}

export function showSidebar(pathname: string): boolean {
  const noSidebar = ['/loanapp/eligibility', '/loanapp/new-loan', '/loanapp/admin', '/loanapp/loan-officer', '/loanapp/payment'];
  return !noSidebar.some(page => pathname?.startsWith(page));
}


export function showHeaderAddress(pathname: string): boolean {
  const noHeaderAddress= ['/loanapp/eligibility', '/loanapp/new-loan', '/loanapp/help', '/loanapp/payment'];
  return !noHeaderAddress.some(page => pathname?.startsWith(page));
}

export function toUSState(states: State[], key?: string): USState | undefined {
  if (!key) return undefined;
  const s = states.find(st => st.key === key);
  return s ? { display: s.display, code: s.code } : undefined;
}

export function normalizeCustomFieldId(value: string): string {
  if (value.startsWith('custom_custom_')) {
    return value.replace('custom_custom_', 'custom_');
  }
  if (value.startsWith('custom_')) {
    return value;
  }
  return `custom_${value}`;
}
